export default {
    CHANGE_OPTION: 'DropDownChangeOption',
};
